module.exports = new __parcel__URL__("changes.0ea22c65.svg").toString();